import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import { useEffect } from "react";
import { GridFilterResetContext } from "../grid";

export default function DropdownFilterBooleanCell(data: any, defaultItem: any, dropDownProps?: any, customProps?: any) {

  return class extends React.Component<any, any> {
    static contextType = GridFilterResetContext;
    constructor(props: any) {
      super(props);
      this.state = {
        selectedValue: null
      };
    }

    public componentDidUpdate() {
      const isGridFilterReset = this.context     
      if (isGridFilterReset && this.state.selectedValue !== null) {        
        customProps.updateGridFilterResetState();
        this.setState({ selectedValue: null });
      }
    }

    public render() {
      return (
        <div className="k-filtercell">
          <DropDownList
            data={data}
            onChange={this.handleChange}
            //value={this.props.value}
            value={this.state.selectedValue}
            //defaultItem={defaultItem}
            {...dropDownProps}
          />
          <button
            className="k-button k-button-icon k-clear-button-visible"
            title="Clear"
            disabled={!this.hasValue(this.state.selectedValue)}
            onClick={this.clearValues}
          >
            <span className="k-icon k-i-filter-clear" />
          </button>
        </div>
      );
    }

    private hasValue(value: any) {
      return value && value !== defaultItem;
    }

    private clearValues = (event: any) => {
      event.preventDefault();
      this.props.onChange({
        value: "",
        operator: "",
        syntheticEvent: event
      });
      this.setState({ selectedValue: null })
    };

    private handleChange = (event: any) => {
      const hasValue = this.hasValue(event.target.value);

      let { operator } = this.props;

      operator = event.target.value.value === "" ? "" :
        event.target.value.value === false ? "isnull" : "eq";


      this.props.onChange({
        value: hasValue ? event.target.value.value : "",
        //operator: hasValue ? "eq" : "",
        operator,
        syntheticEvent: event.syntheticEvent
      });
      this.setState({ selectedValue: event.target.value })
    };
  };
}